var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-2",attrs:{"width":"100%"},on:{"click":function($event){return _vm.$emit('clickTrumb')}}},[_c('div',{staticClass:"pa-3",staticStyle:{"height":"50px"},attrs:{"height":"50px"}},[_c('h4',[_vm._v("#"+_vm._s(_vm.q.id)+" "+_vm._s(_vm.q.t))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }